import { put, call, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import { fetchDashboardSuccess, openUploadDocumentFleetModalSuccess, closeUploadDocumentFleetModalSuccess, fetchCreateDossierButtonSuccess, fetchDashboardButtonsSuccess } from '../../actions/dashboard/dashboard'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import dashboardActionTypes from '../../constants/actions/dashboard/dashboard'
import getSalesmanUserHierarchy from '../../services/salesman/getSalesmanUserHierarchy'
import getDashboard from '../../services/dossier/get/getDashboard'
import getCanCreateDossier from '../../services/dossier/get/getCanCreateDossier'
import getUserDashboardCreateButtons from '../../services/user/getUserDashboardCreateButtons'
import { handleError } from '../errors/errorManager'
import { yesNoModal } from '../modalsListeners/yesNoModal'
import postUploadDocumentFileService from '../../services/dashboard/postUploadFile'
import postUploadFileGeneric from '../../services/dashboard/postUploadFileGeneric'

export function * fetchDashboard ({ organizedUnit, salesmanId }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    organizedUnit = organizedUnit !== '0' ? organizedUnit : null
    const completeSalesmanCombo = yield call(getSalesmanUserHierarchy, auth.token, organizedUnit)
    salesmanId = salesmanId && salesmanId.length > 0 ? salesmanId : null
    const response = yield call(getDashboard, auth.token, organizedUnit, salesmanId)
    yield put(fetchCombosSuccess({
      completeSalesmanCombo
    }))
    yield put(fetchDashboardSuccess(response, salesmanId))
  } catch (error) {
    yield call(handleError, { error })
  } finally {
    yield put(hideLoader())
  }
}

export function * openUploadDocumentFleetModal ({ organizedUnit, brand, isBuyAndSell, code }) {
  try {
    yield put(showLoader())
    yield put(openUploadDocumentFleetModalSuccess(organizedUnit, brand, isBuyAndSell, code))
  } catch (error) {
    yield call(handleError, { error })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchOpenUploadDocumentFleetModal () {
  yield takeEvery(dashboardActionTypes.OPEN_DOCUMENT_UPLOAD_MODAL, openUploadDocumentFleetModal)
}

export function * watchFetchDashboard () {
  yield takeEvery(dashboardActionTypes.FETCH_DASHBOARD, fetchDashboard)
}

export function * checkCanCloseDocumentModal ({ showAdvise, resolve }) {
  if (showAdvise) {
    const acceptCloseModal = yield call(yesNoModal, 'commonDossierSaveWarning')
    if (resolve) resolve(acceptCloseModal)
  } else {
    resolve(true)
  }
}

export function * watchCheckCanCloseUploadDocumentFleetModal () {
  yield takeEvery(dashboardActionTypes.CHECK_CAN_CLOSE_UPLOAD_MODAL, checkCanCloseDocumentModal)
}

export function * closeUploadDocumentFleetModal () {
  yield put(closeUploadDocumentFleetModalSuccess())
}

export function * watchCloseUploadDocumentFleetModal () {
  yield takeEvery(dashboardActionTypes.CLOSE_DOCUMENT_UPLOAD_MODAL, closeUploadDocumentFleetModal)
}

export function * uploadDocumentFleet ({ file, brand, resolve, isBuyAndSell, code }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    let response
    if (code) {
      response = yield call(
        postUploadFileGeneric,
        auth.token,
        file,
        code
      )
    } else {
      response = yield call(
        postUploadDocumentFileService,
        auth.token,
        file,
        brand,
        isBuyAndSell
      )
    }
    if (response) {
      yield put(hideLoader())
      const confirmation = yield call(yesNoModal, 'confirmExcelDocument', null, null, null, null, [{ id: '##NUM_DOSSIERS##', value: response.totalRecords }, { id: '##NUM_CORRECT##', value: response.correct }, { id: '##NUM_INCORRECT##', value: response.incorrect }, { id: '##ERRORS##', value: response.errors }])
      yield put(showLoader())
      if (confirmation) {
        yield put(closeUploadDocumentFleetModalSuccess())
        resolve(true)
      }
    }
  } catch (error) {
    yield call(handleError, { error })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchDashboardUploadDocumentFleet () {
  yield takeEvery(dashboardActionTypes.UPLOAD_DOCUMENT_FLEET, uploadDocumentFleet)
}

export function * fetchCreateDossierButton ({ organizedUnit, salesmanId }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const response = yield call(getCanCreateDossier, auth.token, organizedUnit)

    yield put(fetchCreateDossierButtonSuccess(response))
  } catch (error) {
    yield call(handleError, { error })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchCreateDossierButton () {
  yield takeEvery(dashboardActionTypes.FETCH_CREATE_DOSSIER_BUTTON, fetchCreateDossierButton)
}

export function * fetchDashboardCreateButtons () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const response = yield call(getUserDashboardCreateButtons, auth.token)
    yield put(fetchDashboardButtonsSuccess(response))
  } catch (error) {
    yield call(handleError, { error })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchDashboardCreateButtons () {
  yield takeEvery(dashboardActionTypes.FETCH_CREATE_BUTTONS, fetchDashboardCreateButtons)
}
